export enum MacroUnit {
    percent = '%',
    none = 'ohne Einheit'
}